<template>
  <v-container fluid class="route-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-route`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Route
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-items`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Items
          </v-tab>
          <v-tab-item
            :value="'tab-route'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Route</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeRoute($event, 'routename')"
                        v-bind:value="initvalue.routename"
                        placeholder="Route Name"
                        persistent-hint
                        single-line hint="Enter the route name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=routetypes
                        :value="initvalue.routetype"
                        outlined
                        dense
                        v-on:change="onChangeRoute($event, 'routetype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the route type">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="locations.map(x => {
                          return {text: x.locationname, value: x._id};
                          })"
                        :value="initvalue.locationid"
                        v-on:change="onChangeRoute($event, 'locationid')"
                        v-bind:error="errorindex == 3"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="users.filter(i=>i.userstatus=='Active' && i.locationid==initvalue.locationid).map(i=>{
                          return {text: i.username, value: i._id};
                          })"
                        :value="initvalue.repid"
                        v-on:change="onChangeRoute($event, 'repid')"
                        v-bind:error="errorindex == 4"
                        outlined
                        dense
                        placeholder="Sales Rep"
                        persistent-hint
                        single-line hint="Please choose the sales rep">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-textarea
                        :value="initvalue.routedesc"
                        v-on:change="onChangeRoute($event, 'routedesc')"
                        outlined
                        rows=4
                        label="Route Desc"
                        persistent-hint
                        hint="please enter the route description"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/route/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="editRouteRequest()">
                          Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Route Items</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddItem = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="success"
                          to="/route/list"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :sort-by="['daynum', 'itemnum']"
                        :headers="header_items"
                        :items="routeitems"
                        :items-per-page="500"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteItem" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_item.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteItem = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteRouteItem(delete_item)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.locationid="{ item }">
                          <p class="two-line" v-if="item.locationid!=undefined">{{ routegroups.length>0 && routegroups.find(group=>group._id == item.locationid) ? routegroups.find(group=>group._id == item.locationid)['groupname'] || '' : ''  }}</p>
                        </template>
                        <template v-slot:item.isHalfDay="{ item }">
                          <v-icon v-if="item.isHalfDay==true" size="18" color="blue">mdi-check</v-icon>
                        </template>
                        <template v-slot:item.itemname="{ item }">
                          <p class="two-line"><strong>{{ item.itemname }}</strong></p>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editRouteItemDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteRouteItemDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddItem"
      persistent
      width="1000px"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="1">
                <v-text-field
                  v-model="add_item.daynum"
                  class="mb-4"
                  placeholder="Day"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Day"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  v-model="add_item.itemnum"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_item.itemname"
                  label="Name"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_item.itemdesc"
                  label="Desc"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch
                  dense
                  color="primary"
                  v-model="add_item.isHalfDay"
                  hint="Half Day"
                  :false-value="0"
                  persistent-hint
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddItem=false; add_item={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addRouteItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="onChangeItem($event, 'daynum')"
                  :value="edit_item.daynum"
                  class="mb-4"
                  placeholder="Day"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Day"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemnum')"
                  :value="edit_item.itemnum"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemname')"
                  :value="edit_item.itemname"
                  label="Name"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemdesc')"
                  :value="edit_item.itemdesc"
                  label="Desc"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch
                  dense
                  color="primary"
                  v-model="edit_item.isHalfDay"
                  v-on:change="onChangeItem($event, 'isHalfDay')"
                  v-bind:value="edit_item ? edit_item.isHalfDay : false"
                  :false-value="0"
                  hint="Half Day"
                  persistent-hint
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditItem=false; edit_item={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editRouteItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      header_items: [
        { text: "Day", value: "daynum", width: "15px" },
        { text: "Num", value: "itemnum", width: "15px" },
        { text: "Name", value: "itemname", width: "15%" },
        { text: "Desc", value: "itemdesc" },
        { text: "Half", value: "isHalfDay", width: "8%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      
      routeitems: [],
      routetypes: ['Route', 'Other Route'],
      edit_route: {},
      add_item: {},
      edit_item: {},
      change_route: {},
      change_item: {},
      delete_item: {},
      error: undefined,
      haserror: false,
      errorindex: undefined,
      isDeleteItem: false,
      isAddItem: false,
      isEditItem: false,
      footer: {'items-per-page-options': [500, 1000, 5000]},
    }
  },
  computed: {
    ...mapState('Location', ['locations']),
    ...mapState('Route', ['isReceiving']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Route', [ 'getRouteRequest','deleteRouteItemRequest','insertRouteItemRequest', 'updateRouteRequest','updateRouteItemRequest' ]),
    ...mapActions('User', ['getUsersRequest']),
    async addRouteItemRequest() {
      this.isAddItem = false;
      this.add_item.routeid = this.initvalue._id;
      let result = await this.insertRouteItemRequest(this.add_item);
      console.log('1', result)
      this.routeitems.push(result);
      this.add_item = {};
    },
    deleteRouteItemDialog(item) {
      this.isDeleteItem = true;
      this.delete_item = { _id: item._id, itemname: item.itemname };
    },
    async deleteRouteItem(payload) {
      this.isDeleteItem = false;
      let response = await this.deleteRouteItemRequest(payload);
      let index = this.routeitems.findIndex((trans) => trans._id == response._id);
      this.routeitems.splice(index, 1);
    },
    editRouteItemDialog(item) {
      this.edit_item = Object.assign({}, item);
      this.change_item = {};
      this.isEditItem = true;
    },
    async editRouteRequest() {
      this.change_route._id = this.initvalue._id;
      await this.updateRouteRequest(this.change_route);
      router.push('/route/list');
    },
    async editRouteItemRequest() {
      this.isEditItem = false;
      this.change_item.routeitemid = this.edit_item._id;
      let response = await this.updateRouteItemRequest(this.change_item);
      let index = this.routeitems.findIndex((x) => x._id == response._id);
      this.routeitems.splice(index, 1, response);
      this.edit_item = {};
    }, 
    onChangeRoute(value, field){
      this.change_route[field] = value;
    },
    onChangeItem(value, field){
      this.change_item[field] = value;
    },      
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'RouteList' });
    let result = await this.getRouteRequest(this.initvalue._id);
    this.routeitems = Object.assign([], result.items);

    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
